import React from 'react';
import { Link } from 'react-router-dom';
import { Diamond, ArrowRight, Sun, Flower2, Plug, Lightbulb } from 'lucide-react';
import { homeHero } from './data';

const MiniIcon: React.FC<{ kind: 'plug' | 'bulb' }> = ({ kind }) =>
  kind === 'plug' ? (
    <Plug className="io-home-hero__mini-icon" size={22} strokeWidth={1.75} aria-hidden />
  ) : (
    <Lightbulb className="io-home-hero__mini-icon" size={22} strokeWidth={1.75} aria-hidden />
  );

export const HomeHero: React.FC = () => {
  return (
    <section className="io-home-hero" aria-labelledby="io-home-hero-title">
      <div className="io-home-hero__tiles" aria-hidden />
      <div className="io-home-hero__grid-lines" aria-hidden />
      <div className="io-home-hero__inner">
        <div className="io-home-hero__stack">
          <div className="io-home-hero__head">
            <h1 id="io-home-hero-title" className="io-home-hero__title">
              <span className="io-home-hero__title-part io-home-hero__title-part--1">
                {homeHero.titleLine1}
              </span>
              <span className="io-home-hero__title-part io-home-hero__title-part--2">
                <span className="io-home-hero__title-highlight">{homeHero.titleLine2Highlight}</span>
                {homeHero.titleLine2Rest}
              </span>
              <span className="io-home-hero__title-part io-home-hero__title-part--3">
                {homeHero.titleLine3}
              </span>
            </h1>
            <p className="io-home-hero__subtitle">{homeHero.subtitle}</p>
          </div>
          <div className="io-home-hero__actions">
            <Link to={homeHero.primaryCta.to} className="io-home-hero__cta">
              {homeHero.primaryCta.label}
              <ArrowRight className="io-home-hero__cta-arrow" size={24} strokeWidth={2} aria-hidden />
            </Link>
            <p className="io-home-hero__trust">
              <Diamond className="io-home-hero__trust-icon" size={16} strokeWidth={1.75} aria-hidden />
              <span>{homeHero.trustLine}</span>
            </p>
          </div>
        </div>

        <div className="io-home-hero__showcase" aria-hidden>
          <div className="io-home-hero__showcase-side io-home-hero__showcase-side--left">
            <div className="io-home-hero__left-cluster">
              <Flower2 className="io-home-hero__deco-flower" size={56} strokeWidth={1.25} />
              <div className="io-home-hero__left-stack">
                <div className="io-home-hero__hub">
                  <Sun className="io-home-hero__hub-sun" size={40} strokeWidth={1.5} />
                  <div className="io-home-hero__hub-track" />
                </div>
                <div className="io-home-hero__mini-row">
                  {homeHero.miniCards.map(card => (
                    <div key={card.id} className="io-home-hero__mini-card">
                      <MiniIcon kind={card.icon} />
                      <span className="io-home-hero__mini-label">{card.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="io-home-hero__showcase-center">
            <div className="io-home-hero__shot">
              <img
                src={homeHero.heroImage}
                alt={homeHero.heroImageAlt}
                className="io-home-hero__img"
                width={832}
                height={553}
                loading="eager"
              />
            </div>
          </div>

          <div className="io-home-hero__showcase-side io-home-hero__showcase-side--right">
            <div className="io-home-hero__right-cluster">
              <div className="io-home-hero__switch-card">
                <div className="io-home-hero__switch-photo" />
                <p className="io-home-hero__switch-title">{homeHero.switchCard.label}</p>
                <div className="io-home-hero__switch-meta">
                  <span className="io-home-hero__switch-dot" />
                  <span className="io-home-hero__switch-status">{homeHero.switchCard.status}</span>
                  <span className="io-home-hero__switch-pill">{homeHero.switchCard.state}</span>
                </div>
              </div>
              <Sun className="io-home-hero__deco-sun" size={56} strokeWidth={1.25} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
